import { createContext, useContext, useState } from 'react';
import { useCheckout } from './checkout';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const userDataInitialValues = {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        phoneNumberCountryCode: '',
        country: '',
    };
    const initialFormErrors = {
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        country: true,
    };

    const [userData, setUserData] = useState({ ...userDataInitialValues });
    const [agreeWithTermsAndConditions, setAgreeWithTermsAndConditions] = useState(false);
    const [experiencesAgreeWithTermsAndConditions, setExperiencesAgreeWithTermsAndConditions] = useState(false);
    const [formErrors, setFormErrors] = useState(initialFormErrors);
    const [submitted, setSubmitted] = useState(false);

    const { termsToAccept } = useCheckout();

    const canSubmitForm = (checkingFromPayment = false) => {
        const formHasErrors = Object.values(formErrors).some((errorValue) => errorValue);

        if (!checkingFromPayment) {
            setSubmitted(true);
        }

        if (formHasErrors || !agreeWithTermsAndConditions || (!experiencesAgreeWithTermsAndConditions && termsToAccept?.length > 0)) {
            return false;
        }
        return true;
    };

    const resetForm = () => {
        setUserData(userDataInitialValues);
        setFormErrors(initialFormErrors);
        setSubmitted(false);
        setAgreeWithTermsAndConditions(false);
        setExperiencesAgreeWithTermsAndConditions(false);
    };

    return (
        <UserContext.Provider
            value={{
                userData,
                setUserData,
                resetForm,
                canSubmitForm,
                submitted,
                setSubmitted,
                formErrors,
                setFormErrors,
                agreeWithTermsAndConditions,
                setAgreeWithTermsAndConditions,
                experiencesAgreeWithTermsAndConditions,
                setExperiencesAgreeWithTermsAndConditions,
            }}>
            {children}
        </UserContext.Provider>
    );
};

UserProvider.displayName = 'UserProvider';

export const useUser = () => useContext(UserContext);
